import Avatar from '@/images/avatar/avatar.png';
import HomeBanner from '@/images/home-banner.jpg';
import AdsImage from '@/images/ipb-training/ads.png';
import Logo from '@/images/logo/logo-elearning.png';
import AboutImage from '@/images/mascot.jpg';
import PATH from '@/routes/path';
import { CONSTANTS } from '@/utils';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';

const NAME = 'E-Learning';
const NAME_SECONDARY = 'E-Learning';
const DESCRIPTION = 'Excellence hub for professional and vocational skill based on applied life science.';
const ADDRESS =
  'Rukan Graha Depok Mas, Blok. B. 02, Jl. Arif Rahman Hakim No.3, Depok, Kec. Pancoran Mas, Kota Depok, Jawa Barat 16431.';
const EMAIL = 'hello@badr-interactive.com';
const PHONE = '(+62) 812-8816-7422';
const LOGO = Logo;
const BANNER = HomeBanner;
const CAMPAIGN_VIDEO = 'https://www.youtube.com/watch?v=hdX4gmRFQjs';
const ADS_BANNER = {
  image: AdsImage,
  url: PATH.AUTH_LOGIN,
};
const MAIN_SITE = {
  title: 'ipbtraining.com',
  url: 'https://ipbtraining.com/',
};

const IPX_BASE = 'https://ipx-server.sarbeh.com/_ipx';

const BUSINESS_TYPE = CONSTANTS.BUSINESS_TYPE.TYPE_RETAIL;

const SOCIAL_MEDIA = {
  FACEBOOK: {
    title: 'Facebook',
    icon: <FaFacebook />,
    url: 'https://www.facebook.com/badrinteractive',
  },
  INSTAGRAM: {
    title: 'Instagram',
    icon: <FaInstagram />,
    url: 'https://www.instagram.com/badrinteractive/',
  },
  LINKEDIN: {
    title: 'LinkedIn',
    icon: <FaLinkedin />,
    url: 'https://www.linkedin.com/company/badr-interactive',
  },
  YOUTUBE: {
    title: 'YouTube',
    icon: <FaYoutube />,
    url: 'https://youtube.com/c/BadrInteractiveChannel',
  },
};

const ABOUT_US = {
  title: {
    value: 'Selamat Datang',
    transactionKey: 'welcome',
  },
  description: (
    <div>
      <p className="inline leading-8 bg-zinc-100">E-Learning - merupakan platform milik Badr Interactive</p>
      <br />
      <br />
      <p className="inline leading-8 bg-zinc-100">
        E-Learning menawarkan solusi bagi pelanggan melalui penyelenggaraan kegiatan bisnis berbasis kepakaran Badr
        Interactive, khususnya dalam bidang pembelajaran dan pengembangan keterampilan sumberdaya manusia
      </p>
    </div>
  ),
  image: AboutImage,
};

const FEATURES = [
  {
    title: 'Fitur Satu',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum neque quod dolore omnis, quas animi ipsa quia delectus?',
    image: 'https://image.flaticon.com/icons/png/512/1998/1998575.png',
  },
  {
    title: 'Fitur Dua',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum neque quod dolore omnis, quas animi ipsa quia delectus?',
    image: 'https://image.flaticon.com/icons/png/512/1998/1998575.png',
  },
  {
    title: 'Fitur Tiga',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum neque quod dolore omnis, quas animi ipsa quia delectus?',
    image: 'https://image.flaticon.com/icons/png/512/1998/1998575.png',
  },
];

const TESTIMONIALS = {
  sliders: [
    {
      id: 0,
      name: 'Jeriansyah',
      role: 'Alumni Peserta Program Prakerja',
      institution: 'Kemenko Bidang Perekonomian RI',
      avatar: Avatar,
      testimonial: 'Pembelajaran ini sangat membantu untuk menjalankan atau memulai bisnis dari awal',
    },
    {
      id: 1,
      name: 'Bayu Anggara',
      role: 'Founder',
      institution: 'Fishlog',
      avatar: Avatar,
      testimonial:
        'Keren banget, walaupun startup kami masih dalam tahap market validation, namun sangat membantu untuk mengembangkan bisnis kami kedepannya.',
    },
    {
      id: 2,
      name: 'Rinaldi',
      role: 'Founder',
      institution: 'Lakuliner',
      avatar: Avatar,
      testimonial:
        'Good Experience, Good Insight dan antusias para Founders menyempurnakan pengalaman kami dalam mengikuti pembelajaran ini.',
    },
  ],
  grid: [
    {
      author: 'Ahmed Rayhan P',
      role: 'Frontend Developer',
      institution: process.env.REACT_APP_NAME,
      testimonial:
        'Nihil est fugiat dolorem aut tempora reiciendis ipsum. Cum ratione iusto modi magni ut. Perspiciatis est facere labore ut magnam non rerum rem. Deleniti vel nihil id ut. Et et qui quas possimus illum aut eos. Enim tempore et deserunt.',
      backgroundSrc:
        'https://image.freepik.com/free-vector/beautiful-mountain-blue-sky-with-sea-view-background_105940-540.jpg',
    },
    {
      author: 'John Doe',
      role: 'Backend Developer',
      institution: 'Institution.id',
      testimonial:
        'Porro error alias aut consequatur ut. Occaecati provident nihil voluptatem quia quibusdam et ut. Perspiciatis cumque sed cumque. Dolor provident corrupti.',
      backgroundSrc:
        'https://images.unsplash.com/photo-1453728013993-6d66e9c9123a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8dmlld3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80',
    },
  ],
};

const FAQ = [
  {
    question: 'Apakah seorang pemula bisa ikut belajar?',
    answer:
      'Nostrum inventore hic alias consequatur ipsam dolor ut. Delectus ea consequatur voluptates labore qui inventore consectetur. Illo amet provident ratione quidem. Officia nihil omnis qui enim aut quod alias et est.',
  },
  {
    question: 'Apakah tersedia jaminan uang kembali dan kerja?',
    answer:
      'Nostrum inventore hic alias consequatur ipsam dolor ut. Delectus ea consequatur voluptates labore qui inventore consectetur. Illo amet provident ratione quidem. Officia nihil omnis qui enim aut quod alias et est.',
  },
  {
    question: 'Apakah tersedia komunitas kelas belajar?',
    answer:
      'Nostrum inventore hic alias consequatur ipsam dolor ut. Delectus ea consequatur voluptates labore qui inventore consectetur. Illo amet provident ratione quidem. Officia nihil omnis qui enim aut quod alias et est.',
  },
  {
    question: `Apakah ${process.env.REACT_APP_NAME} menyediakan beasiswa?`,
    answer:
      'Nostrum inventore hic alias consequatur ipsam dolor ut. Delectus ea consequatur voluptates labore qui inventore consectetur. Illo amet provident ratione quidem. Officia nihil omnis qui enim aut quod alias et est.',
  },
  {
    question: 'Bagaimana cara memulai switch career?',
    answer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam congue metus lorem. Praesent porttitor lectus non mattis venenatis. Aliquam nec magna faucibus, accumsan libero ut, sagittis nibh. Vivamus posuere, nisl sagittis luctus interdum, velit turpis cursus enim, posuere pretium metus eros ut ante. Curabitur sollicitudin semper mauris, eu viverra leo tincidunt ut. In hac habitasse platea dictumst. Duis in felis non mi viverra placerat varius nec purus. Maecenas facilisis bibendum ligula, a pharetra leo dapibus vel. Donec ornare urna lacus, sed tempus mi finibus consequat.',
  },
  {
    question: 'Privilege lain apa lagi yang bisa saya dapatkan?',
    answer:
      'Nostrum inventore hic alias consequatur ipsam dolor ut. Delectus ea consequatur voluptates labore qui inventore consectetur. Illo amet provident ratione quidem. Officia nihil omnis qui enim aut quod alias et est.',
  },
];

export const CLIENT = {
  NAME,
  NAME_SECONDARY,
  DESCRIPTION,
  ADDRESS,
  BANNER,
  BUSINESS_TYPE,
  ADS_BANNER,
  EMAIL,
  PHONE,
  LOGO,
  SOCIAL_MEDIA,
  CAMPAIGN_VIDEO,
  MAIN_SITE,
  ABOUT_US,
  FEATURES,
  TESTIMONIALS,
  FAQ,
  IPX_BASE,
};
